import { WholesaleCatalogType } from '@cbgms/api'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Checkbox, TextField } from '@carsys/form'
import { IFormValues } from './types'
import { useFormikContext } from 'formik'

export const hasHBaseFields = (selectedCatalogType: WholesaleCatalogType) =>
  Boolean(selectedCatalogType === WholesaleCatalogType.CARSYS_PRODUCT_TREE || selectedCatalogType === WholesaleCatalogType.HBASE)

export const CatalogFieldsHbase = () => {
  const { t } = useTranslation()
  const {
    values: { wholesaleCatalogType }
  } = useFormikContext<IFormValues>()
  const renderHbaseFields = useMemo(() => hasHBaseFields(wholesaleCatalogType), [wholesaleCatalogType])

  if (!renderHbaseFields) return null
  return (
    <>
      <TextField name='HbaseOverrideSupplierID' label={t('wholesaler-catalog.HbaseOverrideSupplierID')} />
      <TextField name='HbaseOverrideAPIKey' label={t('wholesaler-catalog.HbaseOverrideAPIKey')} />
      <TextField name='HbaseOverrideMGAppID' label={t('wholesaler-catalog.HbaseOverrideMGAppID')} />
      <TextField name='HbaseOverrideMGAppSecret' label={t('wholesaler-catalog.HbaseOverrideMGAppSecret')} />
      <Checkbox name='HbaseMapSurchargeFromCatalog' label={t('wholesaler-catalog.HbaseMapSurchargeFromCatalog')} />
    </>
  )
}
